import React, { useState } from 'react';
import { useLocale } from '../../context/LocaleContext';
import { WORKSHOP_2026_FAQ } from '../../data/workshop2026Faq';
import { PAST_WORKSHOPS } from '../../data/workshop2026Content';
import { Meeting } from '../../services/meetingService';
import { formatWorkshopDayTimeRange } from '../../services/workshop2026Service';
import WorkshopFaqInlineAsk from './WorkshopFaqInlineAsk';
import styles from '../../styles/workshop2026Page.module.css';

interface Workshop2026FaqSectionProps {
  isSignedIn: boolean;
  onLoginForQuestion: () => void;
  userEmail?: string;
  userDisplayName?: string;
  meeting?: Meeting | null;
}

const Workshop2026FaqSection: React.FC<Workshop2026FaqSectionProps> = ({
  isSignedIn,
  onLoginForQuestion,
  userEmail,
  userDisplayName,
  meeting = null,
}) => {
  const { t } = useLocale();
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  return (
    <section className={styles.learnSection}>
      <h2 className={styles.learnHeading}>{t('workshop.2026.faq.heading')}</h2>
      <div className={styles.faqList}>
        {WORKSHOP_2026_FAQ.map((item) => {
          const isOpen = expandedId === item.id;
          const question = t(`workshop.2026.faq.${item.id}.question`);
          return (
            <div key={item.id} className={styles.faqItem}>
              <button
                type="button"
                className={styles.faqQuestion}
                onClick={() => toggle(item.id)}
                aria-expanded={isOpen}
              >
                <span>{question}</span>
                <span className={styles.faqChevron} aria-hidden>
                  {isOpen ? '−' : '+'}
                </span>
              </button>
              {isOpen && (
                <div className={styles.faqAnswer}>
                  {item.isAskQuestion ? (
                    <WorkshopFaqInlineAsk
                      isSignedIn={isSignedIn}
                      onLoginForQuestion={onLoginForQuestion}
                      userEmail={userEmail}
                      userDisplayName={userDisplayName}
                    />
                  ) : item.id === 'time-commitment' ? (
                    <p className={styles.faqAnswerText}>
                      {t('workshop.2026.faq.time_commitment_answer', {
                        schedule: formatWorkshopDayTimeRange(meeting),
                      })}
                    </p>
                  ) : item.id === 'past-workshops' ? (
                    <>
                      <p className={styles.faqAnswerText}>
                        {t('workshop.2026.faq.past_workshops_answer')}
                      </p>
                      <ul className={styles.pastWorkshopList}>
                        {PAST_WORKSHOPS.map((w) => (
                          <li key={w.year}>
                            <strong>{w.year}</strong> — {t(w.summaryKey)}
                          </li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <p className={styles.faqAnswerText}>
                      {t(`workshop.2026.faq.${item.id}.answer`)}
                    </p>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Workshop2026FaqSection;
